import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let GlobalUniqueIdConfig: IRestfulConfigMap = {
    "globalUniqueIdService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getAll: {
                method: "GET",
                path: "common/keys",
                paramDefaults: {
                    size: "@size"
                }
            }
        }
    }
}

export { GlobalUniqueIdConfig };